export const SHAREPOINT_FQDN_URL = `daveytreeexpert.sharepoint.com`;
export const SHAREPOINT_URL = `https://${SHAREPOINT_FQDN_URL}`;
export const DAVEY_IDP_URL = `https://idp.davey.com`;
